"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const lib_1 = require("@brandfree-front/lib");
const mobx_react_1 = require("mobx-react");
const GaButton_1 = __importDefault(require("../util/GaButton"));
const DealerNotice_1 = __importDefault(require("./notices/DealerNotice"));
const StoresUtil_1 = require("../util/StoresUtil");
const mobx_1 = require("mobx");
let Landing = class Landing extends react_1.default.Component {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "translateStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "ssoStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "disposer", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
    }
    componentDidMount() {
        this.disposer = (0, mobx_1.reaction)(() => (this.ssoStore.isHardAuthWithCustomer || this.ssoStore.isDealerWithSelectedCustomer) && this.ssoStore.canRepresent, (result) => {
            if (result) {
                window.location.assign('/gdpr');
            }
        }, { fireImmediately: true });
    }
    componentWillUnmount() {
        this.disposer();
    }
    render() {
        const { translate } = this.translateStore;
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(lib_1.Grid, { align: ['center-xs'] },
                react_1.default.createElement(lib_1.GridColumn, { width: ['xs-12', 'md-10', 'lg-6'] },
                    react_1.default.createElement(DealerNotice_1.default, null),
                    react_1.default.createElement(lib_1.Text, { className: "text-center" },
                        react_1.default.createElement(lib_1.Heading, { className: "h2 text-primary" }, translate('landing.title')),
                        react_1.default.createElement("p", null, translate('landing.greetingInfo')),
                        react_1.default.createElement(lib_1.ProcessList, { className: "text__margin-double text-left" },
                            react_1.default.createElement(lib_1.ProcessListItem, { title: translate('landing.horizontalSteps1') }),
                            react_1.default.createElement(lib_1.ProcessListItem, { title: translate('landing.horizontalSteps2') }),
                            react_1.default.createElement(lib_1.ProcessListItem, { title: translate('landing.horizontalSteps3') })),
                        react_1.default.createElement(GaButton_1.default, { id: "landing-open-login", text: translate('sso.login'), className: "text__margin-double", iconRight: "#arrow-right", onClick: () => this.ssoStore.openSsoIframe() }))))));
    }
};
Landing = __decorate([
    StoresUtil_1.injectStores,
    mobx_react_1.observer
], Landing);
exports.default = Landing;
